<div class="card-view-only-container">
  <p-card styleClass="custom-card">
    <div class="card-header-section">
      <div class="header-content">
        <div class="title-section">
          <h2 class="card-title">{{ getTitle() }}</h2>
        </div>
        <div class="action-section">
          @if(getId() && getHasPermissionEdit()) {
          <p-button id="viewOnlyEditButton" label="Edit" icon="pi pi-pen-to-square" size="small"
            (onClick)="toggleEdit.emit()" />
          }
        </div>
      </div>
      <p-divider />
    </div>

    <div class="card-content-section">
      @for(data of filteredDataList(); let index = $index; track data.name) {
      @if (!shouldSkip(data.name)) {
      @if (data.subItems.length === 0 || getIsQuote()) {
      <div class="data-row">
        <div class="data-label">
          <i class="pi {{ getFieldIcon(data.name) }} {{ getFieldIconColor(data.name) }}"></i>
          <span>{{ data.name }}</span>
        </div>
        <div class="data-value">
          @if (data.value === 'True' || data.value === 'False') {
          <span class="boolean-value">{{ data.value === 'True' ? 'Yes' : 'No' }}</span>
          } @else {
          @if (data.name !== 'Products' && data.name !== getPhoneName()) {
          <span>{{ !data.value ? '--' : data.value }}</span>
          }
          @if (data.name === getPhoneName()) {
          <span>{{ data.value | phoneMask }}</span>
          }
          @if (getIsQuote() && data.subItems.length > 0) {
          <app-quote-product-multi-select [dataList]="data.subItems"></app-quote-product-multi-select>
          }
          }
        </div>
      </div>
      } @else {

      @if (data.subItems.length > 0 && !getIsQuote()) {
      <div class="section-header" [ngClass]="{ 'section-spacing': index > 0 }">
        <h3 class="section-title">{{ data.name }}</h3>
        <p-divider styleClass="m-0" />
      </div>
      @for(sub of data.subItems; track sub.name) {
      @if (!shouldSkip(sub.name)) {
      <div class="data-row">
        <div class="data-label">
          <i class="pi {{ getFieldIcon(sub.name) }} {{ getFieldIconColor(sub.name) }}"></i>
          <span>{{ sub.name }}</span>
        </div>
        <div class="data-value">
          <span>{{ !sub.value ? '--' : (sub.value === 'True' ? 'Yes' : (sub.value === 'False' ? 'No' : sub.value)) }}</span>
        </div>
      </div>
      }
      }
      }
      }
      }
      }
    </div>
  </p-card>
</div>